import {Component, OnInit} from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {RoutingService} from '../../services/routing-service/routing.service';
import {Form, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../../services/api-service/api.service';

@Component({
  selector: 'app-callback-modal',
  templateUrl: './callback-modal.component.html',
  styleUrls: ['./callback-modal.component.scss']
})
export class CallbackModalComponent implements OnInit {

  calbackData: FormGroup;

  public leadDress = '';
  public disableBtn = true;

  toggleCallbackModal = (event) => {
   
    this.leadDress = null;
    this.calbackData.get('name').setValue(null);
    this.calbackData.get('phone').setValue(null);
    this.calbackData.get('email').setValue(null);
    this.calbackData.get('dress').setValue(null);
    this.calbackData.get('dressPrice').setValue(null);
    
    if(event.target.dataset.dress){
      this.leadDress = event.target.dataset.dress;
      this.calbackData.get('dress').setValue(this.leadDress);
      this.calbackData.get('dressPrice').setValue(event.target.dataset.dressprice);
    }
   
    let callBackModal = document.getElementsByClassName('callback-modal')[0];
    let animationTarget = document.getElementsByClassName('animation-target')[0];
    callBackModal.classList.toggle('open');
    animationTarget.classList.toggle('--blured');
  }

  closeCallBackModal = (event) => {
    let callBackModal = document.getElementsByClassName('callback-modal')[0];
    // console.warn(callBackModal);
    let animationTarget = document.getElementsByClassName('animation-target')[0];
    callBackModal.classList.remove('open');
    animationTarget.classList.remove('--blured');
  }

  onSubmit = (event) => {
    this.apiService.sendLead(this.calbackData.value).subscribe(value => {
        // console.log(value);
    });   

    this.toggleCallbackModal(event);
  }

  constructor(
    private UIService: UiService, 
    private routingService: RoutingService, 
    private fb: FormBuilder, 
    
    private apiService: ApiService) {
    this.UIService.listenCallbackModalToggle().subscribe(value => {
      this.toggleCallbackModal(value);
    });
    // this.routingService.listenToRouteChange().subscribe(value => {
    //   this.closeCallBackModal(value);
    //   console.warn(value);
    //   console.warn('should close');
    // });
  }

  ngOnInit() {
    this.calbackData = this.fb.group({
      name: ['', Validators.required],
      phone: ['', Validators.required],
      email: [''],
      dress: [''],
      dressPrice: ['']
    });



  }

}
